import { createBrowserRouter } from "react-router-dom";
import { MainLayout } from "./app/components/layout/MainLayout";
import { Home } from "./app/pages/Home";
import { Programs } from "./app/pages/Programs";
// import { ProgramDetails } from "./app/pages/programDetails";
import ProgramDetails from "./app/pages/programDetails";
import { Schools } from "./app/pages/Schools";
import { About } from "./app/pages/About";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "programs", element: <Programs /> },
      { path: "programs/:slug", element: <ProgramDetails /> },
      { path: "schools", element: <Schools /> },
      { path: "about", element: <About /> },
      { path: "*", element: <div className="pt-32 text-center text-2xl">Page Not Found</div> },
    ],
  },
]);
